import { action, createRequestTypes } from './base';

export const productActionTypes = {
  SEARCH_PRODUCTS: createRequestTypes('SEARCH_PRODUCTS'),
  SEARCH_BY_REFERENCE_ID: createRequestTypes('SEARCH_BY_REFERENCE_ID'),
  GET_PRODUCTS: createRequestTypes('GET_PRODUCTS'),
  GET_PRODUCT_BY_ID: createRequestTypes('GET_PRODUCT_BY_ID'),
  GET_LOW_ORG_PRODUCTS: createRequestTypes('GET_LOW_ORG_PRODUCTS'),
  ADD_PRODUCT_VENDOR: createRequestTypes('ADD_PRODUCT_VENDOR'),
  ADD_PRODUCT_TO_INV: createRequestTypes('ADD_PRODUCT_TO_INV'),
  UPDATE_PRODUCT_TO_INV: createRequestTypes('UPDATE_PRODUCT_TO_INV'),
  CREATE_INDENT: createRequestTypes('CREATE_INDENT'),
  GET_INDENT: createRequestTypes('GET_INDENT'),
  UPDATE_SA_WORKFLOW_STEP: createRequestTypes('UPDATE_SA_WORKFLOW_STEP'),
  GET_INDENT_BY_ID: createRequestTypes('GET_INDENT_BY_ID'),
  UPDATE_INDENT_STATUS: createRequestTypes('UPDATE_INDENT_STATUS'),
  UPDATE_INDENT: createRequestTypes('UPDATE_INDENT'),
  SET_DEFAULT_OFFER: createRequestTypes('SET_DEFAULT_OFFER'),
  GET_PRODUCT_OFFERS: createRequestTypes('GET_PRODUCT_OFFERS'),
  GET_SELLER_PRODUCTS: createRequestTypes('GET_SELLER_PRODUCTS'),
  GET_ORG_PRODUCTS: createRequestTypes('GET_ORG_PRODUCTS'),
  GET_ORG_PRODUCT_BY_ID: createRequestTypes('GET_ORG_PRODUCT_BY_ID'),
  DELETE_INDENT: createRequestTypes('DELETE_INDENT'),
  GET_RECENT_TRANSACTIONS: createRequestTypes('GET_RECENT_TRANSACTIONS'),
  GET_INVENTORY_LOGS: createRequestTypes('GET_INVENTORY_LOGS'),
  GET_PRODUCT_BY_SKUS: createRequestTypes('GET_PRODUCT_BY_SKUS'),
  PRINT_BARCODE: createRequestTypes('PRINT_BARCODES'),
  GET_SELLER_CODES: createRequestTypes('GET_SELLER_CODES'),
  DOWNLOAD_PRODUCT_BATCHES_LIST: createRequestTypes('DOWNLOAD_PRODUCT_BATCHES_LIST'),
  DOWNLOAD_INVENTORY_LOGS: createRequestTypes('DOWNLOAD_INVENTORY_LOGS'),
  BULK_UPDATE_PRODUCTS: createRequestTypes('BULK_UPDATE_PRODUCTS'),
  GET_BULK_UPLOAD_META_DATA: createRequestTypes('GET_BULK_UPLOAD_META_DATA'),
  BULK_UPLOAD_PRODUCT: createRequestTypes('BULK_UPLOAD_PRODUCT'),
  PRODUCTS_BULK_UPDATE: createRequestTypes('PRODUCTS_BULK_UPDATE'),
  GET_TALLY_PRODUCTS: createRequestTypes('GET_TALLY_PRODUCTS'),

};

/**
 * @param addProductToInventoryLoading
 * @param page
 * @param keyword
 * @param groupBySku
 * @param tenantId
 * @param category
 * @param sellerId
 * @param offerProduct
 * @param payload
 * @param callback
 * @param createIndentLoading
 * @param indentId
 * @param addProductToInventory
 */
class ProductActions {
  /**
   * @param tenantId
   * @param productSkuId
   * @param tenantDepartmentId
   * @param productId
   * @return {{type: *}}
   */
  getProductById = (tenantId, productSkuId, tenantDepartmentId, callback, filterReservedBatches, productSkuIds) => action(productActionTypes.GET_PRODUCT_BY_ID.REQUEST, {
    tenantId, productSkuId, tenantDepartmentId, callback, filterReservedBatches, productSkuIds,
  });

  /**
   *
   * @param getProductByIdLoading
   * @return {{type: *}}
   */
  getProductByIdLoading = (getProductByIdLoading) => action(productActionTypes.GET_PRODUCT_BY_ID.LOADING, {
    getProductByIdLoading,
  });

  /**
   *
   * @param selectedProduct
   * @return {{type: *}}
   */
  getProductByIdSuccess = (selectedProduct) => action(productActionTypes.GET_PRODUCT_BY_ID.SUCCESS, {
    selectedProduct,
  });

  /**
   * @param keyword
   * @param page
   * @return {{type: *}}
   */
  searchProducts = (params, callback, newCallback) => action(productActionTypes.SEARCH_PRODUCTS.REQUEST, {
    params, callback, newCallback
  });

  /**
   *
   * @type {{type: *}}
   */
  searchProductsLoading = (searchProductsLoading, isAdvanceProductSearch) => action(productActionTypes.SEARCH_PRODUCTS.LOADING, {
    searchProductsLoading, isAdvanceProductSearch,
  });

  /**
   *
   * @param searchResults
   * @return {{type: *}}
   */
  searchProductsSuccess = (searchResults, isAdvanceProductSearch) => action(productActionTypes.SEARCH_PRODUCTS.SUCCESS, {
    searchResults, isAdvanceProductSearch,
  });

  // searchReferenceId
  searchByReferenceId = (params, callback) => action(productActionTypes.SEARCH_BY_REFERENCE_ID.REQUEST, {
    params, callback,
  });

  /**
   *
   * @type {{type: *}}
   */
  searchByReferenceIdLoading = (searchByReferenceIdLoading) => action(productActionTypes.SEARCH_BY_REFERENCE_ID.LOADING, {
    searchByReferenceIdLoading,
  });

  /**
   *
   * @param searchResults
   * @return {{type: *}}
   */
  searchByReferenceIdSuccess = (searchByReferenceIdResults) => action(productActionTypes.SEARCH_BY_REFERENCE_ID.SUCCESS, {
    searchByReferenceIdResults,
  });

  /**
   * @param page
   * @param keyword
   * @param groupBySku
   * @param tenantId
   * @param category
   * @param sellerId
   * @param forOffers
   * @param stockStatus
   * @param limit
   * @param tenantDepartmentId
   * @param excludeOutOfStock
   * @param productType
   * @param category
   * @param isSalesProduct
   * @param isPurchaseProduct
   * @param search
   * @param sortBy
   * @param filterReservedQuantity
   * @param barcode
   * @param isShopifyProduct
   * @return {{type: *}}
   */
  getProducts = (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct, departmentId, advanceFilters, isListScreen, productSkuIds) => action(productActionTypes.GET_PRODUCTS.REQUEST, {
    keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct, departmentId, advanceFilters, isListScreen, productSkuIds
  });

  /**
   *
   * @param getProductsLoading
   * @return {{type: *}}
   */
  getProductsLoading = (getProductsLoading) => action(productActionTypes.GET_PRODUCTS.LOADING, {
    getProductsLoading,
  });

  /**
   * @param products
   * @param forOffers
   * @return {{type: *}}
   */
  getProductsSuccess = (products, forOffers) => action(productActionTypes.GET_PRODUCTS.SUCCESS, {
    products,
    forOffers,
  });

  /**
   *
   * @param page
   * @param tenantId
   * @return {{type: *}}
   */
  getLowOrgProducts = (page, tenantId) => action(productActionTypes.GET_LOW_ORG_PRODUCTS.REQUEST, {
    page,
    tenantId,
  });

  /**
   *
   * @param getLowOrgProductsLoading
   * @return {{type: *}}
   */
  getLowOrgProductsLoading = (getLowOrgProductsLoading) => action(productActionTypes.GET_LOW_ORG_PRODUCTS.LOADING, {
    getLowOrgProductsLoading,
  });

  /**
   * @param lowOrgProducts
   * @return {{type: *}}
   */
  getLowOrgProductsSuccess = (lowOrgProducts) => action(productActionTypes.GET_LOW_ORG_PRODUCTS.SUCCESS, {
    lowOrgProducts,
  });

  /**
   * @param payload
   * @param page
   * @param keyword
   * @param callback
   * @return {{type: *}}
   */
  addProductVendor = (payload, page, keyword, callback) => action(productActionTypes.ADD_PRODUCT_VENDOR.REQUEST, {
    payload,
    page,
    keyword,
    callback,
  });

  /**
   *
   * @param addProductVendorLoading
   * @return {{type: *}}
   */
  addProductVendorLoading = (addProductVendorLoading) => action(productActionTypes.ADD_PRODUCT_VENDOR.LOADING, {
    addProductVendorLoading,
  });

  /**
   *
   * @param payload
   * @param callback
   * @param getProductsPayload
   * @return {{type: *}}
   */
  addProductToInventory = (payload, callback, getProductsPayload) => action(productActionTypes.ADD_PRODUCT_TO_INV.REQUEST, {
    payload,
    callback,
    getProductsPayload,
  });

  addProductToInventoryLoading = (addProductToInventoryLoading) => action(productActionTypes.ADD_PRODUCT_TO_INV.LOADING, {
    addProductToInventoryLoading,
  });

  /**
   *
   * @param {*} updateProductToInventoryLoading
   * @return
   */
  updateProductToInventoryLoading = (updateProductToInventoryLoading) => action(productActionTypes.UPDATE_PRODUCT_TO_INV.LOADING, {
    updateProductToInventoryLoading,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateProductToInventory = (payload, callback) => action(productActionTypes.UPDATE_PRODUCT_TO_INV.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param {*} payload
   * @param {*} callback
   * @param withApproval
   * @return
   */
  createIndent = (payload, callback, withApproval) => action(productActionTypes.CREATE_INDENT.REQUEST, {
    payload,
    callback,
    withApproval,
  });

  /**
   *
   * @param {*} createIndentLoading
   * @return
   */
  createIndentLoading = (createIndentLoading) => action(productActionTypes.CREATE_INDENT.LOADING, {
    createIndentLoading,
  });

  /**
   * @param {*} payload
   * @param {*} callback
   * @param withApproval
   * @return
   */
  updateIndent = (payload, callback, withApproval) => action(productActionTypes.UPDATE_INDENT.REQUEST, {
    payload,
    callback,
    withApproval,
  });

  /**
   *
   * @param {*} updateIndentLoading
   * @return
   */
  updateIndentLoading = (updateIndentLoading) => action(productActionTypes.UPDATE_INDENT.LOADING, {
    updateIndentLoading,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateIndentStatus = (payload, callback) => action(productActionTypes.UPDATE_INDENT_STATUS.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} updateIndentStatusLoading
   * @return
   */
  updateIndentStatusLoading = (updateIndentStatusLoading) => action(productActionTypes.UPDATE_INDENT_STATUS.LOADING, {
    updateIndentStatusLoading,
  });

  /**
   * @param {*} page
   * @param {*} tenantId
   * @param {*} indentId
   * @param adjustmentEntityType
   * @param searchKeyword
   * @return
   */
  getIndent = (page, tenantId, indentId, adjustmentEntityType, searchKeyword, department, limit) => action(productActionTypes.GET_INDENT.REQUEST, {
    page, tenantId, indentId, adjustmentEntityType, searchKeyword, department, limit,
  });

  /**
   * @param getIndentLoading
   * @param getLowOrgProductsLoading
   * @return {{type: *}}
   */
  getIndentLoading = (getIndentLoading) => action(productActionTypes.GET_INDENT.LOADING, {
    getIndentLoading,
  });

  /**
   * @param indents
   * @param lowOrgProducts
   * @return {{type: *}}
   */
  getIndentSuccess = (indents) => action(productActionTypes.GET_INDENT.SUCCESS, {
    indents,
  });

  /**
   * @param tenantId
   * @param indentId
   * @return {{type: *}}
   */
  getIndentById = (tenantId, indentId, limit) => action(productActionTypes.GET_INDENT_BY_ID.REQUEST, {
    tenantId,
    indentId,
    limit,
  });

  /**
   *
   * @param getIndentByIdLoading
   * @return {{type: *}}
   */
  getIndentByIdLoading = (getIndentByIdLoading) => action(productActionTypes.GET_INDENT_BY_ID.LOADING, {
    getIndentByIdLoading,
  });

  /**
   *
   * @param selectedIndent
   * @return {{type: *}}
   */
  getIndentByIdSuccess = (selectedIndent) => action(productActionTypes.GET_INDENT_BY_ID.SUCCESS, {
    selectedIndent,
  });

  /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  setDefaultOffer = (payload, callback) => action(productActionTypes.SET_DEFAULT_OFFER.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param setDefaultOfferLoading
   * @return {{type: *}}
   */
  setDefaultOfferLoading = (setDefaultOfferLoading) => action(productActionTypes.SET_DEFAULT_OFFER.LOADING, {
    setDefaultOfferLoading,
  });

  /**
   * @param tenantId
   * @param productSkuId
   * @param tenantProductId
   * @return {{type: *}}
   */
  getProductOffers = (tenantId, productSkuId) => action(productActionTypes.GET_PRODUCT_OFFERS.REQUEST, {
    tenantId,
    productSkuId,
  });

  /**
   *
   * @param getProductOffersLoading
   * @return {{type: *}}
   */
  getProductOffersLoading = (getProductOffersLoading) => action(productActionTypes.GET_PRODUCT_OFFERS.LOADING, {
    getProductOffersLoading,
  });

  /**
   *
   * @param productOffers
   * @return {{type: *}}
   */
  getProductOffersSuccess = (productOffers) => action(productActionTypes.GET_PRODUCT_OFFERS.SUCCESS, {
    productOffers,
  });

  /**
   *
   * @param tenantId
   * @param sellerId
   * @param productName
   * @param page
   * @param limit
   * @return {{type: *}}
   */
  getSellerProducts = (tenantId, sellerId, productName, page, limit) => action(productActionTypes.GET_SELLER_PRODUCTS.REQUEST, {
    tenantId,
    sellerId,
    productName,
    page,
    limit,
  });

  /**
   *
   * @param getSellerProductsLoading
   * @return {{type: *}}
   */
  getSellerProductsLoading = (getSellerProductsLoading) => action(productActionTypes.GET_SELLER_PRODUCTS.LOADING, {
    getSellerProductsLoading,
  });

  /**
   *
   * @param sellerProducts
   * @return {{type: *}}
   */
  getSellerProductsSuccess = (sellerProducts) => action(productActionTypes.GET_SELLER_PRODUCTS.SUCCESS, {
    sellerProducts,
  });

  /**
   * @param orgId
   * @param page
   * @param tenantId
   * @param limit
   * @param keyword
   * @param stockStatus
   * @param tenantDepartmentId
   * @param productSkuId
   * @param productType
   * @param category
   * @param isSalesProduct
   * @param isPurchaseProduct
   * @return {{type: *}}
   */
  getOrgProducts = (orgId, tenantId, page, limit, keyword, stockStatus, tenantDepartmentId, productSkuId, productType, category, isSalesProduct, isPurchaseProduct, isArchive) => action(productActionTypes.GET_ORG_PRODUCTS.REQUEST, {
    orgId, tenantId, page, limit, keyword, stockStatus, tenantDepartmentId, productSkuId, productType, category, isSalesProduct, isPurchaseProduct, isArchive,
  });

  /**
   *
   * @param getOrgProductsLoading
   * @return {{type: *}}
   */
  getOrgProductsLoading = (getOrgProductsLoading) => action(productActionTypes.GET_ORG_PRODUCTS.LOADING, {
    getOrgProductsLoading,
  });

  /**
   *
   * @param orgProducts
   * @return {{type: *}}
   */
  getOrgProductsSuccess = (orgProducts) => action(productActionTypes.GET_ORG_PRODUCTS.SUCCESS, {
    orgProducts,
  });

  /**
   * @param productId
   * @param orgId
   * @param tenantId
   * @param productSkuId
   * @param callback
   * @return {{type: *}}
   */
  getOrgProductById = (orgId, tenantId, productSkuId, callback, pendingFromVendor, productSkuIds) => action(productActionTypes.GET_ORG_PRODUCT_BY_ID.REQUEST, {
    orgId, tenantId, productSkuId, callback, pendingFromVendor, productSkuIds,
  });

  /**
   *
   * @param getOrgProductByIdLoading
   * @return {{type: *}}
   */
  getOrgProductByIdLoading = (getOrgProductByIdLoading) => action(productActionTypes.GET_ORG_PRODUCT_BY_ID.LOADING, {
    getOrgProductByIdLoading,
  });

  /**
   *
   * @param selectedOrgProduct
   * @return {{type: *}}
   */
  getOrgProductByIdSuccess = (selectedOrgProduct) => action(productActionTypes.GET_ORG_PRODUCT_BY_ID.SUCCESS, {
    selectedOrgProduct,
  });

  /**
   * @param deleteIndentLoading
   * @param {*} updateIndentLoading
   * @return
   */
  deleteIndentLoading = (deleteIndentLoading) => action(productActionTypes.DELETE_INDENT.LOADING, {
    deleteIndentLoading,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  deleteIndent = (payload, callback) => action(productActionTypes.DELETE_INDENT.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} tenantId
   * @param {*} tenantProductId
   * @param {*} page
   * @param {*} limit
   * @return
   */
  getRecentTransactions = (payload, callback) => action(productActionTypes.GET_RECENT_TRANSACTIONS.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param {*} getRecentTransactionsLoading
   * @return
   */
  getRecentTransactionsLoading = (getRecentTransactionsLoading) => action(productActionTypes.GET_RECENT_TRANSACTIONS.LOADING, {
    getRecentTransactionsLoading,
  });

  /**
   *
   * @param {*} recentTransactions
   * @return
   */
  getRecentTransactionsSuccess = (recentTransactions) => action(productActionTypes.GET_RECENT_TRANSACTIONS.SUCCESS, {
    recentTransactions,
  });

  /**
   * @param {*} tenantId
   * @param {*} tenantProductId
   * @param {*} page
   * @param orgId
   * @param productSkuId
   * @param {*} limit
   * @param tenantDepartmentId
   * @return
   */
  getInventoryLogs = (tenantId, orgId, tenantProductId, productSkuId, page, limit, tenantDepartmentId, startDate, endDate, searchKeyword) => action(productActionTypes.GET_INVENTORY_LOGS.REQUEST, {
    tenantId,
    orgId,
    tenantProductId,
    productSkuId,
    page,
    limit,
    tenantDepartmentId,
    startDate,
    endDate,
    searchKeyword,
  });

  /**
   * @param getInventoryLogsLoading
   * @return
   */
  getInventoryLogsLoading = (getInventoryLogsLoading) => action(productActionTypes.GET_INVENTORY_LOGS.LOADING, {
    getInventoryLogsLoading,
  });

  /**
   * @param inventoryLogs
   * @param {*} recentTransactions
   * @return
   */
  getInventoryLogsSuccess = (inventoryLogs) => action(productActionTypes.GET_INVENTORY_LOGS.SUCCESS, {
    inventoryLogs,
  });

  /**
 * @param tenantId
 * @param productSkuId
 * @param tenantDepartmentId
 * @param productId
 * @return {{type: *}}
 */
  // getProductBySkus = (skuCodes, tenantIds, tenantSellerIds, tenantDepartmentIds, orgId, skuData, callback) => action(productActionTypes.GET_PRODUCT_BY_SKUS.REQUEST, {
  //   skuCodes, tenantIds, tenantSellerIds, tenantDepartmentIds, orgId, skuData, callback,
  // })
  getProductBySkus = (payload, callback) => action(productActionTypes.GET_PRODUCT_BY_SKUS.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param getProductByIdLoading
   * @return {{type: *}}
   */
  getProductBySkusLoading = (getProductBySkusLoading) => action(productActionTypes.GET_PRODUCT_BY_SKUS.LOADING, {
    getProductBySkusLoading,
  });

  /**
   *
   * @param selectedProduct
   * @return {{type: *}}
   */
  getProductBySkusSuccess = (selectedProduct) => action(productActionTypes.GET_PRODUCT_BY_SKUS.SUCCESS, {
    selectedProduct,
  });

  getSellerCodes = (sellerCode, orgId, callback) => action(productActionTypes.GET_SELLER_CODES.REQUEST, {
    sellerCode, orgId, callback,
  });

  /**
   *
   * @param getProductByIdLoading
   * @return {{type: *}}
   */
  getSellerCodesLoading = (getSellerCodesLoading) => action(productActionTypes.GET_SELLER_CODES.LOADING, {
    getSellerCodesLoading,
  });

  /**
   *
   * @param selectedProduct
   * @return {{type: *}}
   */
  getSellerCodesSuccess = (getSellerCodesSuccess) => action(productActionTypes.GET_SELLER_CODES.SUCCESS, {
    getSellerCodesSuccess,
  });

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  printBarcodes = (payload, callback) => action(productActionTypes.PRINT_BARCODE.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param printBarcodesLoading
   * @returns {{type: *}}
   */
  printBarcodesLoading = (printBarcodesLoading) => action(productActionTypes.PRINT_BARCODE.LOADING, {
    printBarcodesLoading,
  });

  /**
   *
   * @param printedBarcodes
   * @returns {{type: *}}
   */
  printBarcodesSuccess = (printedBarcodes) => action(productActionTypes.PRINT_BARCODE.SUCCESS, {
    printedBarcodes,
  });

  updateSAWorkflowStep = (payload, callback) => action(productActionTypes.UPDATE_SA_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param updateSTWorkflowStepLoading
   * @return {{type: *}}
   */
  updateSAWorkflowStepLoading = (updateSAWorkflowStepLoading) => action(productActionTypes.UPDATE_SA_WORKFLOW_STEP.LOADING, {
    updateSAWorkflowStepLoading,
  });
  // Download product batches list

  downloadProductBatchesList = (payload, callback) => action(productActionTypes.DOWNLOAD_PRODUCT_BATCHES_LIST.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param downloadProductBatchesListLoading
   * @return {{type: *}}
   */

  downloadProductBatchesListLoading = (downloadProductBatchesListLoading) => action(productActionTypes.DOWNLOAD_PRODUCT_BATCHES_LIST.LOADING, {
    downloadProductBatchesListLoading,
  });

  // Download inventory logs

  downloadInventoryLogs = (payload, callback) => action(productActionTypes.DOWNLOAD_INVENTORY_LOGS.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param downloadInventoryLogsLoading
   * @return {{type: *}}
   */

  downloadInventoryLogsLoading = (downloadInventoryLogsLoading) => action(productActionTypes.DOWNLOAD_INVENTORY_LOGS.LOADING, {
    downloadInventoryLogsLoading,
  });

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  bulkUpdateProducts = (payload, callback) => action(productActionTypes.BULK_UPDATE_PRODUCTS.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param bulkUpdateProductsLoading
   * @returns {{type: *}}
   */
  bulkUpdateProductsLoading = (bulkUpdateProductsLoading) => action(productActionTypes.BULK_UPDATE_PRODUCTS.LOADING, {
    bulkUpdateProductsLoading,
  });

  /**
   *
   * @returns {{type: *}}
   */
  getBulkUploadMetadata = () => action(productActionTypes.GET_BULK_UPLOAD_META_DATA.REQUEST, {});

  /**
   *
   * @param getBulkUploadMetadataLoading
   * @returns {{type: *}}
   */
  getBulkUploadMetadataLoading = (getBulkUploadMetadataLoading) => action(productActionTypes.GET_BULK_UPLOAD_META_DATA.LOADING, {
    getBulkUploadMetadataLoading,
  });

  /**
   *
   * @param bulkUploadMetadata
   * @returns {{type: *}}
   */
  getBulkUploadMetadataSuccess = (bulkUploadMetadata) => action(productActionTypes.GET_BULK_UPLOAD_META_DATA.SUCCESS, {
    bulkUploadMetadata,
  });

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  bulkUploadProducts = (payload, callback) => action(productActionTypes.BULK_UPLOAD_PRODUCT.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param bulkUploadProductsLoading
   * @returns {{type: *}}
   */
  bulkUploadProductsLoading = (bulkUploadProductsLoading) => action(productActionTypes.BULK_UPLOAD_PRODUCT.LOADING, {
    bulkUploadProductsLoading,
  });

  /**
   *
   * @param bulkUploadResponse
   * @returns {{type: *}}
   */
  bulkUploadProductsSuccess = (bulkUploadResponse) => action(productActionTypes.BULK_UPLOAD_PRODUCT.SUCCESS, {
    bulkUploadResponse,
  });

  /**
   *
   * @param bulkUploadError
   * @returns {{type: *}}
   */
  bulkUploadProductsError = (bulkUploadError) => action(productActionTypes.BULK_UPLOAD_PRODUCT.ERROR, {
    bulkUploadError,
  });

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  productsBulkUpdate = (payload, callback) => action(productActionTypes.PRODUCTS_BULK_UPDATE.REQUEST, {
    payload, callback,
  });

  /**
   *
   * @param productsBulkUpdateLoading
   * @returns {{type: *}}
   */
  productsBulkUpdateLoading = (productsBulkUpdateLoading) => action(productActionTypes.PRODUCTS_BULK_UPDATE.LOADING, {
    productsBulkUpdateLoading,
  });

  /**
   *
   * @param bulkUpdateResponse
   * @returns {{type: *}}
   */
  productsBulkUpdateSuccess = (bulkUpdateResponse) => action(productActionTypes.PRODUCTS_BULK_UPDATE.SUCCESS, {
    bulkUpdateResponse,
  });

  /**
   *
   * @param bulkUpdateError
   * @returns {{type: *}}
   */
  productsBulkUpdateError = (bulkUpdateError) => action(productActionTypes.PRODUCTS_BULK_UPDATE.ERROR, {
    bulkUpdateError,
  });

  getTallyProducts = (itId, orgId, searchKeyword, selectedProduct, callback) => action(productActionTypes.GET_TALLY_PRODUCTS.REQUEST, {
    itId, orgId, searchKeyword, selectedProduct, callback
  });

  /**
   *
   * @param getTallyProductsLoading
   * @return {{type: *}}
   */
  getTallyProductsLoading = (getTallyProductsLoading) => action(productActionTypes.GET_TALLY_PRODUCTS.LOADING, {
    getTallyProductsLoading,
  });

  /**
   *
   * @param tallyProducts
   * @return {{type: *}}
   */
  getTallyProductsSuccess = (tallyProducts) => action(productActionTypes.GET_TALLY_PRODUCTS.SUCCESS, {
    tallyProducts,
  });
}
export default new ProductActions();
